import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-mb-0"
}
const _hoisted_2 = {
  key: 1,
  class: "p-mb-0"
}
const _hoisted_3 = { class: "p-formgroup" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Utente selezionato ")
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = { class: "p-col-6 p-grid" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col" }, "Nome:", -1)
const _hoisted_9 = { class: "p-col" }
const _hoisted_10 = { class: "p-col-6 p-grid" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col" }, "Cognome:", -1)
const _hoisted_12 = { class: "p-col" }
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col-12 p-grid" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col-3" }, "Ruolo:", -1)
const _hoisted_16 = { class: "p-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_UserAutocomplete = _resolveComponent("UserAutocomplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    style: { width: '450px' },
    modal: true,
    class: "p-fluid",
    onShow: _ctx.onShow,
    onHide: _ctx.onHide,
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0
  }, {
    header: _withCtx(() => [
      (_ctx.onlyOneOrder)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_1, " Assegna l'ordine #" + _toDisplayString(_ctx.order.id), 1))
        : (_openBlock(), _createElementBlock("h2", _hoisted_2, " Assegna ordini selezionati ")),
      _createVNode(_component_Toast, { group: "this_dialog" })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Annulla",
        icon: "pi pi-times",
        class: "p-button-secondary",
        onClick: _ctx.onCancel
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Conferma",
        icon: "pi pi-check",
        disabled: !_ctx.user,
        loading: _ctx.isLoading,
        onClick: _ctx.onConfirm
      }, null, 8, ["disabled", "loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FloatLabel, { label: "A chi vuoi assegnare?" }, {
            default: _withCtx(() => [
              _createVNode(_component_UserAutocomplete, {
                modelValue: _ctx.user,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.user = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        (_ctx.user)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "p-mt-3 p-shadow-2"
            }, {
              title: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.name), 1)
                  ]),
                  _createElementVNode("span", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.user.surname), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`user-badge role-${_ctx.user.role}`)
                      }, _toDisplayString(_ctx.$t(`role.${_ctx.user.role}`)), 3)
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["onShow", "onHide"]))
}